window.addEventListener('DOMContentLoaded', () => {
  styleCartSelectors()
})

window.addEventListener('custom::cart-updated', () => {
  styleCartSelectors()
})

function styleCartSelectors() {
  setTimeout(() => { //Needed because was not working on quantity change

    let cartItems = document.querySelectorAll('.js-cart-item')

    if (!!!cartItems) return;

    cartItems.forEach((cartItem, index) => {


      let subscriptionSelector = $(cartItem).find(`[name="cart-item__subscription-select-${cartItem.dataset.itemid}-${cartItem.dataset.sellingplan}"]`);

      subscriptionSelector.off('change');

      subscriptionSelector.select2({
        dropdownParent: subscriptionSelector.closest('.mini-cart__body')
      });

      subscriptionSelector.on('change', function () {
        updateSellingPlan(this.value, index + 1, cartItem.querySelector('hh-quantity-input')?._value);
      });

    })

  }, 1);
}

async function updateSellingPlan(sellingPlanId, itemIndex, itemQuantity) {
  try {

    document.querySelector('hh-mini-cart').loading = true

    let payload = {
      'line': itemIndex,
      'quantity': itemQuantity,
      'selling_plan': sellingPlanId
    }

    let sections = "mini-cart,header,cart-notification,main-cart"

    let res = await fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        sections,
        ...payload
      })
    })

    let response = await res.json()

    reRenderShopifySections(response)
    styleCartSelectors()

  } catch (error) {

    console.log(error);

  } finally {

    document.querySelector('hh-mini-cart').loading = false

  }


}

function reRenderShopifySections(response, selector = "[data-rerender]") {

  return Object.keys(response.sections).forEach((key) => {
    const updatedNode = new DOMParser().parseFromString(response.sections[key], "text/html").querySelectorAll(selector);

    document.querySelector(`[id^="shopify-section-"][id*="${key}"]`)?.querySelectorAll(selector).forEach((node, index) => {
      node.replaceWith(updatedNode[index]);
    });
  });
};
